<!-- ColorCard.vue - Individual color selection card -->
<template>
  <div
    class="color-card"
    :class="{ 
      'is-selected': isSelected && !isExpanded,
      'is-expanded': isExpanded 
    }"
    @click="handleClick"
  >
    <div class="color-image-wrapper">
        <img
                v-if="color.featured_image"
                :src="color.featured_image.src"
                :alt="color.featured_image.alt"
                class="color-image"
        />
        <div v-else class="no-image-placeholder">
            Image not loaded
        </div>
      <!-- Badge is visible when quantity is set -->
      <div v-if="quantity > 0" class="quantity-badge">
        {{ quantity }}
      </div>
    </div>
    <div class="color-name-frame">
      <div class="color-name">
        {{ formattedColor }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ColorCard',

  props: {
    color: {
      type: Object,
      required: true
    },
    quantity: {
      type: Number,
      default: 0
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isExpanded: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick() {
      this.$emit('select', this.color)
      this.syncGalleryThumbnail()
    },

    /**
     * Finds the MLP theme gallery thumbnail whose data-title (or img alt)
     * matches the clicked color image alt text, then clicks it to sync the slider.
     *
     * Uses bubbles:false to prevent the programmatic click from reaching
     * document's handleClickOutside listener in ColorSizeSection, which would
     * otherwise collapse the qty selector immediately after it opens.
     */
    syncGalleryThumbnail() {
      // Disable gallery sync on mobile/tablet (<=1024px).
      // Requires the Shopify theme to preload gallery images from 1025px.
      if (window.innerWidth <= 1401) return

      const altText = this.color?.featured_image?.alt
      if (!altText) return

      const normalized = altText.trim().toLowerCase()

      const thumbnails = document.querySelectorAll(
        '.product_gallery_nav .gallery-cell.product-gallery__thumbnail'
      )

      for (const thumb of thumbnails) {
        const thumbTitle = (
          thumb.getAttribute('data-title') ||
          thumb.querySelector('img')?.getAttribute('alt') ||
          ''
        ).trim().toLowerCase()

        if (thumbTitle === normalized) {
          // Use bubbles:false so this programmatic click does NOT propagate
          // to document and does NOT trigger handleClickOutside
          thumb.dispatchEvent(new MouseEvent('click', { bubbles: false, cancelable: true }))
          break
        }
      }
    }
  },

  computed: {
    formattedColor() {
      return this.color.title.replace(/-/g, ' ')
    }
  }
}
</script>

<style scoped lang="scss">
@use '@/styles/components/color-card';
</style>
